export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	CONTENTS = 'contents',

	PRODUCTS = 'products',

	PRODUCT_TYPES = 'product-types',
	COMPONENT_CATEGORIES = 'component-categories',
	COMPONENTS = 'components',
	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',
	ATTRIBUTE_GROUPS = 'attribute-groups',
	SETTINGS = 'settings',
}
